import "../messageStyles.css";

import { HardDriveDownload } from "lucide-react";
import OptionMenu from "../OptionMenu";
import LocationLink from "../LocationLink";
import ImagePreview from "./ImagePreview";
import { getMediaObjectUrl } from "@/utils/mediaCache";

interface ReceivedImageMessageProps {
  id: number;
  created: string;
  time: string;
  image: {
    media: string;
    dname: string;
    fname: string;
    msg: string;
    lat?: string | null;
    lng?: string | null;
  };
}

const ReceivedImageMessage = ({
  id,
  created,
  time,
  image,
}: ReceivedImageMessageProps) => {
  // Cached blob URL so the base64 is decoded once, not re-decoded on every remount.
  const mediaUrl = getMediaObjectUrl(`r:${id}`, image.media);
  return (
    <div key={id} className="message-container">
      <div className="message-time-container">
        <span className="message-time">{created ? time : "now"}</span>
        <div className="options-menu group">
          <div className="flex items-center justify-center gap-4 rounded-md">
            <ImagePreview
              src={mediaUrl}
              alt={image.fname || "spacelinq message"}
              className="image-style"
            />
            <a
              href={mediaUrl}
              download={image.dname}
              title="Download Image"
            >
              <HardDriveDownload />
            </a>
          </div>
          <OptionMenu />
        </div>
        {image.msg.length > 0 && (
          <div className="options-menu group">
            <div className="message-text-container received-color max-w-fit">
              <p className="attachment-message">{image.msg}</p>
            </div>
            <OptionMenu />
          </div>
        )}
        <LocationLink lat={image.lat} lng={image.lng} />
      </div>
    </div>
  );
};

export default ReceivedImageMessage;
